import  React, { useEffect, useState } from 'react';

import MobileNavBar from "components/MobileNavBar/MobileNavBar";
import VerticalNavButton from "../components/VerticalNavButton/VerticalNavButton";

import ArticlePreview from "../components/ArticlePreview/ArticlePreview";
import ArticlePreviewSkeleton from "../components/ArticlePreview/ArticlePreviewSkeleton";

const Module = () => {
    const [data_news, set_data_news] = useState([]);
    useEffect(() => {
        // Google Sheet 정보 가져오기 (News, Publications, People)
        (() => {
            fetch('/api/sheet-data?source=content')
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                set_data_news(data.news);
            })
            .catch((error) => console.error("Fetching error: ", error));
        })();
    }, []);

    return (
        <div>
            <MobileNavBar>
                <a className="other-nav-home" href="/" draggable={false}>The TCR Lab</a>
                <VerticalNavButton label="Featured News" src="#content-news"/>
                <VerticalNavButton label="Publications" src="/publications"/>
            </MobileNavBar>

            <div className="back-button-bar">
                <a className="back-button" href="/" draggable={false}>Back to Home</a>
            </div>
            <div className="content-horizontal-flex gap-10">
                <div id="desktop-nav-wrapper">
                    <div id="other-nav">
                        <a className="other-nav-home" href="/" draggable={false}>The TCR Lab</a>
                        <VerticalNavButton label="Featured News" src="#content-news" highlight="true"/>
                        <VerticalNavButton label="Publications" src="/publications"/>
                    </div>
                </div>

                <div id="content">
                    <section id="content-news">
                        <div className="title-wrapper">
                            <h1>The&nbsp;TCR&nbsp;Lab:&thinsp;&thinsp;Featured News</h1>
                            <span className="text-gray pr-2">{data_news.length}&nbsp;results</span>
                        </div>

                        <div className="list-articles">
                            {data_news.length === 0
                                ? Array.from({ length: 4 }).map((_, index) => <ArticlePreviewSkeleton key={index} />)
                                : data_news.map((article, index) => <ArticlePreview article={article} key={index}/>)}
                        </div>
                    </section>
                </div>
            </div>
        </div>);
};
export default Module;